<div class="special-instructions">
    <div class="special-instructions__inner">

        <ng-template #left>
            <shared-indicator size="sm">+</shared-indicator>
        </ng-template>

        <ng-template #right>
            <shared-circle-btn [icon]="isExpanded ? 'up': 'down'" feel="transparent" [hoverShadow]="false">
            </shared-circle-btn>
        </ng-template>

        <shared-header (click)="toggleCollapse()" class="special-instructions__hd" type="4" [right]="right"
            [marginTop]="headerMarginTop" [marginBottom]="headerMarginBottom" [paddingTop]="headerPaddingTop"
            [paddingBottom]="headerPaddingBottom" [left]="left">
            Add special instructions
        </shared-header>

        <div class="special-instructions__bd" *ngIf="isExpanded">
            <shared-forms-input [value]="value" [placeholder]="placeholder" type="textarea"
                (onChange)="handleOnChange($event)">
            </shared-forms-input>
        </div>

    </div>
</div>